import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";

import * as colors from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { ABOUT_CLASSES } from "./constants";

export const AboutContainer = styled(Container)(({ theme }) => {
  const { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } = getFormatMedia(theme);

  return {
    display: "flex",

    [`& .${ABOUT_CLASSES.title}`]: {
      marginBottom: theme.spacing(2),
      ...theme.typography.h5,
      [BREAKPOINT_TABLET]: {
        marginBottom: theme.spacing(3),
        ...theme.typography.h4,
      },
      [BREAKPOINT_DESKTOP]: {
        marginBottom: theme.spacing(4),
      },
    },

    [`& .${ABOUT_CLASSES.text}`]: {
      marginBottom: theme.spacing(7),
      color: colors.COLOR_GREYSCALE_BLACK_75,
      ...theme.typography.body2,
      [BREAKPOINT_TABLET]: theme.typography.body1["&.articleLarge"],
      [BREAKPOINT_DESKTOP]: { marginBottom: theme.spacing(8) },
    },

    [`& .${ABOUT_CLASSES.showMore}`]: {
      display: "inline",
      ...theme.typography.body2,
      textDecoration: "underline",
      textUnderlineOffset: "1px",
      color: colors.COLOR_PRIMARY_BLACK,
      cursor: "pointer",
      whiteSpace: "nowrap",
      [BREAKPOINT_TABLET]: theme.typography.body1["&.articleLargeLink"],
    },

    [`& .${ABOUT_CLASSES.hideOnMobile}`]: {
      display: "none",
      [BREAKPOINT_TABLET]: {
        display: "flex",
      },
    },
  };
});
